<template>
<div >
    <button class="addButton" @click="addNewQuestion(qSetID)" v-if="isNew" :disabled="disabled">+ Question</button>
    <button class="button" @click="Add()" v-if="!isNew" :disabled="disabled">Edit</button>

    <!-- ACCT NOTE MODAL -->
      <actionmodal ref="mymodal" :key="componentKey"> 
        <template v-slot:body>
            <form >
                <label class="titlelabel">Edit Question: {{question.name}}</label>
                <div >
                    <button class="button" type="button" v-on:click="saveQuestionOnly(question.id)">{{saveButtonText}}</button>
                    <button class="button" type="button" @click="close()">{{cancelButtonText}}</button>
                </div>
                

                <div  class="questionEditPanel vertFlexLeft">
                    <label class="subtitlelabel bold">Question: {{question.name}}</label>
                    <div class="isactive">
                        <input type="checkbox"  v-model="question.isActive" v-on:click="updateIsActive()">
                        <label  class="rosterName" >{{isActiveText}}</label>
                    </div>
                    <div>
                        <div class="horizFlex">
                            <p class="editLabel">{{questionTitleText}}</p>
                            <input class="editText editTextDesc" v-model="question.name"/>
                        </div>
                        <div class="horizFlex">
                            <p class="editLabel">{{questionDescriptionText}}</p>
                            <input class="editText editTextDesc" v-model="question.questionDetails"/>
                        </div>
                        
                        <div class="horizFlex">
                            <img :src="getImage(question.questionDocument)"   class="image" v-if="question.questionDocument!=null" >
                            
                            <div class="vertFlex">
                                <p>{{selectImageButtonText}}</p>
                                <input type="file" @change="Image_onFileChanged"  >
                                <button type="button" class="uploadButton" @click="Image_onUpload()" :disabled='!readyToUpload'>Upload Image</button>
                            </div>
                            
                        </div>
                        <div>
                            <hr>
                        </div>
                        <div class="horizFlex">
                            <p class="optionEditTitle">{{optionTitle}}</p>
                            <button type="button" class="editQuestionButton" v-on:click="addNewOption(question.id)">+ {{addOptionButtonText}}</button>
                        </div>
                        
                        <div v-bind:class="optionClass(question.id,option.id)" v-for="option in question.options" :key="option.id" >
                            <hr>
                            <label class="subtitlelabel bold">Option: {{option.optionText}}</label>
                            <div class="horizFlex">
                                <p class="editLabel">{{optionNameText}}</p>
                                <input class="editText editTextDesc" v-model="option.optionText"/>
                            </div>
                            <div class="horizFlex">
                                <p class="editLabel">{{optionDescriptionText}}</p>
                                <input class="editText editTextDesc" v-model="option.optionDetail"/>
                            </div>
                            <div class="horizFlex">
                                <div class="isactive">
                                    <input type="checkbox"  v-model="option.isValid" v-on:click="updateIsActive()">
                                    <label  class="rosterName" >{{isActiveText}}</label>
                                </div>
                            </div>
                            <div class="horizFlex" >
                                <div class="horizFlex">
                                    <img :src="getImage(option.optionImage)"   class="editImage" v-if="option.optionImage!=''" >
                    
                                    <div class="vertFlex">
                                        <p>{{selectImageButtonText}}</p>
                                        <input type="file" @change="Image_onFileChanged_Option"  >
                                        <button type="button" class="uploadButton" @click="Image_onUpload_Option(option.id)" :disabled='!readyToUpload_Option'>Upload Image</button>
                                    </div>
                                </div>
                            </div>
  
                        </div>    
                    </div>
                </div>

    
                
               
          </form>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import {HTTP} from '../../Repository'
import actionmodal from '../controls/actionmodal.vue'
export default {
    name:'editquestion',
    components:{
        actionmodal,
    },
    props:{
         inquestion:{
            type:Object,
            
        },
        electionId:{
            type:Number,
        },
        isNew:{
            type:Boolean,
            default:false
        },
        disabled:{
          type:Boolean,
          default:false
        },
        questionSetId:{
            type:Number
        }
    },
    mixins:[],
    
    data(){
        return{
            
            question:this.inquestion,

            imageBasePath:'',
            selectedFile:null,
            selectedFileURL:null,
            selectedFilePreview:null,
            
            selectedFileOption:null,
            selectedFileURLOption:null,
            selectedFilePreviewOption:null,

            saveButtonText:'Save',
            cancelButtonText:'Cancel',
           isActiveText:'Is Active',
           questionTitleText:'Question Title',
            questionDescriptionText:'Question Description',
            optionTitle:'Options',
            addOptionButtonText:'Add Option',
            optionNameText:'Option Title',
            optionDescriptionText:'Option Detail',
            selectImageButtonText:'To select a new image, 1. click Choose File and 2. Click Upload Image',
            removeOptionButtonText:'Remove Option',

            errorMessage:'',

            inAddOption:false,
            inUpload:false,
            optionForEdit:-1,
            inUploadOption:false,

            componentKey:0

       
        }
    },
    computed:{
        /* question(){
            return this.myquestion
        }, */
        qSetID(){
            return this.questionSetId
        },
        readyToUpload(){
            return this.selectedFile!=null
        },
        readyToUpload_Option(){
            return this.selectedFileOption!=null
        }
    },
    methods:{
      forcerefresh(){
         // this.componentKey+=1
      },
        close(){
            this.inAddOption=false
            this.inUpload=false
            this.inUploadOption=false
            //if there is a new option, remove it
            if(this.question.options.length>0){
                if(this.question.options[0].id==-1){
                    this.question.options.splice(0,1)
                }
            }
 
            
            this.$emit('refresh')
            this.$refs.mymodal.closeModal()
        },
        async Add(){
            console.log('add')
            this.$refs.mymodal.openModal()
        },
        updateIsActive(){
            this.$emit('showinactive')
        },
        addNewQuestion(qSetID){
            console.log(qSetID)
            if(this.electionId==-1){
                this.$emit("save")
            
            }else{
                
                let newq={'id':'-1','name':'New Question','questionDetails':'','isActive':true,'questionSetID':qSetID,'options':[],'questionDocument':null};
                this.question = newq
                this.$refs.mymodal.openModal()
                console.log(newq)
                
                /* this.selectedResult.questions.splice(0,0,newq);
                this.editQuestion(-1); */
            }
            
        },
        getImageBasePath(){
            this.pleaseWait=true;
            HTTP.post('electionimagepath')
            .then(response=>{
                this.imageBasePath = window.VUE_CONFIG_API + response.data.StringResponse
                console.log("got imagepath " + this.imageBasePath)
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e

            });
        },
        getImage(imagePath){
            console.log(this.imageBasePath + imagePath)
            return this.imageBasePath + imagePath;
            //return require("../assets/" + imagePath)
        },
        optionClass(questionID,optionID){
            var option = this.getOptionByID(optionID)
            if(!option.isValid){
                return "inactiveOption"
            }else{
                return "activeOption";
            }
        },
        Image_onFileChanged(event){
            this.selectedFile = event.target.files[0];
            
            this.selectedFileURL = URL.createObjectURL(this.selectedFile);
            console.log(this.selectedFileURL)
            this.selectedFilePreview= this.selectedFileURL.replace('blob:','')
        },
        Image_onFileChanged_Option(event){
            this.selectedFileOption = event.target.files[0];
            this.selectedFileURLOption = URL.createObjectURL(this.selectedFileOption);
            this.selectedFilePreviewOption= this.selectedFileURLOption.replace('blob:','')
        },
        async Image_onUpload(){
           //if we are new, then autosave first
            if(this.question.id==-1){
                this.inUpload=true
                this.questionforEdit = this.question.id
                this.saveQuestionOnly(this.question.id);
                return
            }

            const mypostparams = new FormData();
            if (this.selectedFile!=null){
                mypostparams.append('Image', this.selectedFile, this.selectedFile.name);
            }
        
            mypostparams.append('ElectionID',this.electionId);
            mypostparams.append('QuestionID',this.question.id);

            console.log('calling api to save image')
            HTTP.post('saveimage',mypostparams)
            .then(response=>{
                console.log(response)
                if(response.data.Successful){
                    
                    if(this.question!=null){
                        this.question.questionDocument = response.data.StringResponse;
                    }
                }else{
                    this.errorMessage=response.data.message;
                    this.showError=true;
                }
            })
            .catch(e=>{
                console.log(e)
                this.errorMessage=e;
                this.showError=true;
            });
 
        },
        async Image_onUpload_Option(optionID){
            console.log('in op upload ' + optionID)
           if(optionID==-1){
                this.inUploadOption=true
                this.optionForEdit=optionID
                this.saveOptionOnly(optionID);
                return
            }
            const mypostparams = new FormData();
            if (this.selectedFileOption!=null){
                mypostparams.append('Image', this.selectedFileOption, this.selectedFileOption.name);
            }
        
            mypostparams.append('ElectionID',this.electionId);
            mypostparams.append('QuestionID',this.question.id);
            mypostparams.append('OptionID',optionID);
            console.log('calling api to save image')
            HTTP.post('saveimage',mypostparams)
            .then(response=>{
                console.log(response)
                if(response.data.Successful){
                    
                    var option = this.getOptionByID(optionID)
                    if(option!=null){
                        option.optionImage = response.data.StringResponse;
                    }
                }else{
                    this.errorMessage=response.data.message;
                    this.showError=true;
                }
            })
            .catch(e=>{
                console.log(e)
                this.errorMessage=e;
                this.showError=true;
            });
 
        },
        getOptionByID(optionID){
         
            var j;

                if(this.question!=undefined){
 
                    for(j=0;j<this.question.options.length;j++){
                        var option = this.question.options[j]
                        if(option.id==optionID){
                            return option;
                        }
                    }
                    
                }
                
            
        },
        
        saveQuestionOnly(){
           
            let req = {
                ElectionQuestion:this.question
            }
            this.pleaseWait=true;
            HTTP.post('savequestion',req)
            .then(response=>{

                if(response.data.Successful){
                    
                    this.question.id=response.data.ResponseInteger
                    if(!this.inAddOption && !this.inUpload){
                        this.$emit('refresh')
                        this.$refs.mymodal.closeModal()
                    }else if(this.inAddOption){
                        this.inAddOption=false
                        this.addNewOption()
                    }else if(this.inUpload){
                        this.inUpload=false
                        this.Image_onUpload()
                    }
                }else{
                    this.errorMessage="API Error: " + response.data.RequestException.Message;
                }
                //this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                console.log('election fail ' + e)
                return e
            });
        },
        addNewOption(){

            if(this.question.id==-1){
                this.inAddOption=true
                this.questionforEdit=this.question.id
                this.saveQuestionOnly();
                console.log('no question yet')
                return
            }
            let newo={'id':'-1', 'optionText':'New Option','optionDetail':'','isValid':true,'optionImage':null};
            console.log(newo)
            if(this.question.options==undefined){
                this.question.options = [newo]
                console.log('new array')
            }else{
                this.question.options.splice(0,0,newo);
            }
            this.forcerefresh()
            
        },
        saveOptionOnly(optionID){
            
            var option = this.getOptionByID(optionID)
            let req = {
                ElectionQuestion:this.question,
                ElectionQuestionOption:option
            }
            this.pleaseWait=true;
            HTTP.post('savequestionoption',req)
            .then(response=>{

                if(response.data.Successful){
                    
                    option.id=response.data.ResponseInteger
                    this.optionForEdit=option.id
                    if(this.inUploadOption){
                        this.inUploadOption=false
                        this.Image_onUpload_Option(option.id)
                    }
                    //this.$emit('refresh')
                    
                }else{
                    this.errorMessage="API Error: " + response.data.RequestException.Message;
                }
                //this.pleaseWait=false;

            })
            .catch(e=>{
                this.pleaseWait=false;
                console.log('election fail ' + e)
                return e
            });
        },
    },
    mounted(){
        this.getImageBasePath()
        
    }
}
</script>

<style>
.titlelabel{
    font-size:x-large;
}
.subtitlelabel{
    font-size:large;
}
.questionEditPanel{
    height:650px;
    overflow-x:hidden;
    overflow-y:scroll;
    margin-top:10px;
    
}
.vertFlexLeft{
    display:flex;
    flex-direction: column;
    text-align: left;
}
.horizFlex{
    display: flex;
    flex-direction: row;
}

.editText{
    height:20px;
    margin-top:10px;
    margin-left:5px;
    width:300px;
    font:inherit;
    font-size:inherit;
}
.editCombo{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:250px;
    margin-top:10px;
    height:25px;
}
.editTextDesc{
    width:350px;
}
.editLabel{
    margin-left:10px;
    margin-top:10px;
    width:200px;
}
.editQuestionButton{
    background-color: rgb(0,158,192);
    border:none;
    border-radius:5px;
    margin-left:3px;
    color:white;
    height:25px;
    margin-top:10px;

}
.uploadButton{
    background-color: rgb(0,158,192);
    border:none;
    border-radius:5px;
    color:white;
    height:25px;
    margin:10px 0px 10px 0px;
    width:100px;
}
.editImage{
    height:60px;
    margin:5px;
}
.previewImage{
    width:60px;
    margin:5px;
}
.removeButton{
    margin:5px;
    text-align: right;
}
.optionTitleLabel{
    font-size:large;
    color:rgb(0,158,192);
    margin-left:25px;
}
.optionDetailLabel{
    margin-top:0px;
    margin-bottom:0px;
    margin-left:25px;
}
.optionEditTitle{
    font-size:large;
    /* color:rgb(0,158,192); */
    color:rgb(0,158,192);
    font-weight: bold;
    margin:10px;
}
.image{
    margin:10px;
    height:80px;
}
.image_option{
    margin:10px 10px 10px 20px;
    height:80px;
}
.bold{
    font-weight: bold;
}

.addButton{

    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 100px;
   height:40px;
   margin-top:5px;
   margin-right:5px;
}
</style>





























